import React, { useState } from "react";

const MenuBar = ({ onRoute }) => {
  const [start, setStart] = useState({ name: "", lat: "", lng: "" });
  const [goal, setGoal] = useState({ name: "", lat: "", lng: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!start.lat || !start.lng || !goal.lat || !goal.lng) {
      alert("출발지와 목적지의 위도/경도를 입력하세요.");
      return;
    }
    onRoute({ start, goal });
  };

  return (
    <div
      style={{
        background: "#2b2f3a",
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        color: "white",
        fontFamily: "Pretendard, sans-serif",
      }}
    >
      <span style={{ fontWeight: "bold", fontSize: "16px" }}>🚗 길찾기</span>

      <input
        type="text"
        placeholder="출발지 위도(lat)"
        value={start.lat}
        onChange={(e) => setStart({ ...start, lat: e.target.value })}
        style={{
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #555",
          width: "130px",
          backgroundColor: "#1E2027",
          color: "white",
        }}
      />
      <input
        type="text"
        placeholder="출발지 경도(lng)"
        value={start.lng}
        onChange={(e) => setStart({ ...start, lng: e.target.value })}
        style={{
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #555",
          width: "130px",
          backgroundColor: "#1E2027",
          color: "white",
        }}
      />

      <span style={{ color: "#999" }}>→</span>

      <input
        type="text"
        placeholder="목적지 위도(lat)"
        value={goal.lat}
        onChange={(e) => setGoal({ ...goal, lat: e.target.value })}
        style={{
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #555",
          width: "130px",
          backgroundColor: "#1E2027",
          color: "white",
        }}
      />
      <input
        type="text"
        placeholder="목적지 경도(lng)"
        value={goal.lng}
        onChange={(e) => setGoal({ ...goal, lng: e.target.value })}
        style={{
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #555",
          width: "130px",
          backgroundColor: "#1E2027",
          color: "white",
        }}
      />

      <button
        onClick={handleSubmit}
        style={{
          backgroundColor: "#59D89E",
          color: "#000",
          fontWeight: "600",
          border: "none",
          borderRadius: "6px",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        길찾기
      </button>
    </div>
  );
};

export default MenuBar;
